import IotAdministration from './iotAdministration' //IOT管理
import LogManagement from './LogManagement' //日志管理
//研发
export default [
    {
        path: 'research',
        name: 'research',
        meta: {
            title: '研发',
            icon: 'research'
        },
        hidden: false,
        component: () => import("@/views/research/index.vue"),
        children:[
            ...LogManagement,
            ...IotAdministration
        ]
    }
]